import React from 'react';
import SearchPlatformExternalPlatformTab from './SearchPlatformExternalPlatformTab';
import SearchPlatformTab from './SearchPlatformTab';
import ExternalBrandLogo from '../components/ExternalBrandLogo';
import Tabs from '../components/Tabs';
import type { DocumentType } from '../graphql/generated/gql';
import { gql } from '../graphql/generated/gql';

const PLATFORMS_FRAGMENT = gql(`
  fragment SearchPlatformTabs_platforms on ExternalSearchPlatform {
    platform
  }
`);

const ICON_HEIGHT = 20;

interface SearchPlatformTabsProps {
  activePlatform?: string;
  setPlatform: (platform?: string) => void;
  encouragedPlatformSet: Set<string>;
  enabledPlatforms: DocumentType<typeof PLATFORMS_FRAGMENT>[];
  slabResultCount: string | null;
  query: string;
  skip: boolean;
  loadPlatformData: (
    query: string,
    platform: string,
  ) => Promise<{ count: number | null }>;
}

const SearchPlatformTabs = ({
  activePlatform,
  setPlatform,
  encouragedPlatformSet,
  enabledPlatforms,
  slabResultCount,
  query,
  skip,
  loadPlatformData,
}: SearchPlatformTabsProps) => (
  <Tabs>
    <SearchPlatformTab
      icon={<ExternalBrandLogo brand="slab" height={ICON_HEIGHT} />}
      name="Slab"
      meta={slabResultCount}
      active={!activePlatform}
      onClick={() => setPlatform()}
    />
    {enabledPlatforms.map(({ platform }) => (
      <SearchPlatformExternalPlatformTab
        active={activePlatform === platform}
        encourageInstallation={encouragedPlatformSet.has(platform)}
        key={platform}
        platformKey={platform}
        setPlatform={setPlatform}
        iconHeight={ICON_HEIGHT}
        query={query}
        skip={skip}
        loadPlatformData={loadPlatformData}
      />
    ))}
  </Tabs>
);

export default SearchPlatformTabs;
